import Quill from 'quill'

/**
 * Suporte mínimo a tabela de verdade no Quill, só pro bloco de assinatura — não é um plugin
 * genérico de tabela (sem redimensionar coluna, sem toolbar própria). O motivo de ser tabela
 * e não float: e-mail (principalmente Outlook, que renderiza com o motor do Word) não sustenta
 * float além do primeiro parágrafo — cada linha nova "cai" pra baixo em vez de ficar ao lado
 * da logo. Tabela com rowspan é o único jeito confiável de 3+ linhas ficarem ao lado da imagem.
 *
 * Ao contrário da tentativa anterior (embed opaco), aqui cada <td> é um Block de verdade do
 * Quill (mesma classe-base de um parágrafo normal) — digitar, colar, apagar, setas e inserir
 * variável funcionam nativamente dentro da célula, porque o Quill entende a estrutura em vez
 * de tratá-la como um blob travado.
 *
 * O <tbody> precisa ser um blot próprio, não só <table>/<tr>/<td>: ao setar innerHTML com uma
 * string "<table><tr>...", o parser HTML do navegador insere um <tbody> implícito entre os
 * dois — sem um blot registrado pra ele, o Quill não reconhece esse nó ao reconstruir a árvore
 * (no reload) e descarta a linha inteira silenciosamente.
 */
const Container: any = Quill.import('blots/container')
const Block: any = Quill.import('blots/block')

export const CLASSE_TABELA_ASSINATURA = 'ql-tabela-assinatura'
export const CLASSE_CELULA_LOGO = 'ql-tabela-assinatura__logo'

export class CelulaAssinaturaBlot extends Block {
  static create(value?: { logo?: boolean }) {
    const node = super.create()

    if (value && value.logo) {
      node.classList.add(CLASSE_CELULA_LOGO)
      node.setAttribute('valign', 'top')
    }

    return node
  }
}
CelulaAssinaturaBlot.blotName = 'celula-assinatura'
CelulaAssinaturaBlot.tagName = 'td'

export class LinhaAssinaturaBlot extends Container {
}
LinhaAssinaturaBlot.blotName = 'linha-assinatura'
LinhaAssinaturaBlot.scope = Quill.import('parchment').Scope.BLOCK_BLOT
LinhaAssinaturaBlot.tagName = 'tr'
LinhaAssinaturaBlot.defaultChild = 'celula-assinatura'
LinhaAssinaturaBlot.allowedChildren = [CelulaAssinaturaBlot]

export class CorpoTabelaAssinaturaBlot extends Container {
}
CorpoTabelaAssinaturaBlot.blotName = 'corpo-tabela-assinatura'
CorpoTabelaAssinaturaBlot.scope = Quill.import('parchment').Scope.BLOCK_BLOT
CorpoTabelaAssinaturaBlot.tagName = 'tbody'
CorpoTabelaAssinaturaBlot.defaultChild = 'linha-assinatura'
CorpoTabelaAssinaturaBlot.allowedChildren = [LinhaAssinaturaBlot]

export class TabelaAssinaturaBlot extends Container {
}
TabelaAssinaturaBlot.blotName = 'tabela-assinatura'
TabelaAssinaturaBlot.scope = Quill.import('parchment').Scope.BLOCK_BLOT
TabelaAssinaturaBlot.tagName = 'table'
TabelaAssinaturaBlot.className = CLASSE_TABELA_ASSINATURA
TabelaAssinaturaBlot.defaultChild = 'corpo-tabela-assinatura'
TabelaAssinaturaBlot.allowedChildren = [CorpoTabelaAssinaturaBlot]

Quill.register(CelulaAssinaturaBlot, true)
Quill.register(LinhaAssinaturaBlot, true)
Quill.register(CorpoTabelaAssinaturaBlot, true)
Quill.register(TabelaAssinaturaBlot, true)
